import {
  ACCESS_TOKEN_EXPIRED,
  INVALID_ACCESS_TOKEN,
  MISSING_AUTH_HEADER,
  NOT_AUTHORIZED_EXCEPTION
} from 'config'

export const isAuthorized = (error: any): boolean => {
  return !(
    error?.name === NOT_AUTHORIZED_EXCEPTION ||
    error?.response?.data?.error?.includes(ACCESS_TOKEN_EXPIRED) ||
    error?.response?.data?.error?.includes(INVALID_ACCESS_TOKEN) ||
    error?.response?.data?.error?.includes(MISSING_AUTH_HEADER) ||
    error?.response?.status === 401
  )
}


export const toSentenceCase = (str?: string): string => {
  if (str == null) return ''
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
